import React from 'react';
import { Header } from "../presentation/Header";
import { Footer } from '../presentation/Footer';

export const ShippingDelivery = () => {
  return (
    <>
      <Header />
      <div className="text-[15px] font-light">
        <div className="container mx-auto p-4 py-10">
          <h1 className="font-normal text-2xl text-center mb-8">SHIPPING & DELIVERY</h1>
          <h2 className="font-normal text-xl mb-8">SHIPPING</h2>
          <p className="mb-6">Below are estimates, the dates shown at checkout will be the most accurate. For International Shipping please allow 5-15 business days and shipping is $25.</p>
          <p className="mb-6">Delivery times are influenced by product availability, geographic location of the product in inventory, your shipping destination and the courier partner's time-to-deliver in your location. Please check your accurate delivery timelines by entering your default pin code at the time of ordering. Please note, some courier partners do not work on Sundays and this is factored in to the delivery dates. Please note, some courier partners do not work on Sundays and this is factored in to the delivery dates.</p>

          <table className="w-full text-left border border-slate-300 mb-6">
            <thead>
              <tr>
                <th className="border border-slate-300 p-2 font-medium">SHIPPING METHOD</th>
                <th className="border border-slate-300 p-2 font-medium">SHIPPING TIME</th>
                <th className="border border-slate-300 p-2 font-medium">SHIPPING FEE</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-slate-300 p-2">Standard</td>
                <td className="border border-slate-300 p-2">4-7 business days</td>
                <td className="border border-slate-300 p-2">$6-$12 or Free Ship on orders $100+</td>
              </tr>
              <tr>
                <td className="border border-slate-300 p-2">Express</td>
                <td className="border border-slate-300 p-2">2-3 business days</td>
                <td className="border border-slate-300 p-2">Add $30</td>
              </tr>
              <tr>
                <td className="border border-slate-300 p-2">Overnight</td>
                <td className="border border-slate-300 p-2">1-2 business days</td>
                <td className="border border-slate-300 p-2">Add $60</td>
              </tr>
            </tbody>
          </table>

          <p className="mb-8">Delivery charge varies with the product you are purchasing. We incur relatively higher shipping costs on low value items. In such cases, charging a nominal delivery charge helps to offset logistics costs. Please check your order summary to understand the delivery charges for individual products.</p>

          <h2 className="font-normal text-xl mb-4">DELIVERY</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 className="font-normal mb-2">What is the estimated delivery time?</h3>
              <p className="mb-10">Delivery times are influenced by product availability, geographic location of the product in inventory, your shipping destination and the courier partner's time-to-deliver in your location</p>

              <h3 className="font-normal mb-2">What happens if I am out when delivery is attempted?</h3>
              <p className="mb-10">Your order will be delivered to the delivery address you have provided to us. If you weren’t available when the courier partner knocked at your door, two additional delivery attempts will follow on successive days.</p>

              <h3 className="font-normal mb-2">How will I be notified about my order?</h3>
              <p className="mb-10">If you have successfully placed an order with us, we will keep you notified at different stages of the journey of your order. An e-mail or SMS will be sent once you've successfully placed your order. We'll also let you know as soon as the seller ships the item(s) to you along with the tracking number(s) for your shipment(s). You can track your orders from the “Track Order” section on our website. We’ll send another communication when your package is on its way to be delivered to your specified address.</p>
            </div>

            <div>
              <h3 className="font-normal mb-2">How much does delivery cost?</h3>
              <p className="mb-10">Delivery charge varies with the product you are purchasing. We incur relatively higher shipping costs on low value items. In such cases, charging a nominal delivery charge helps to offset logistics costs.</p>

              <h3 className="font-normal mb-2">When will the deliveries take place?</h3>
              <p className="mb-10">Our courier partner will try to deliver between 9:00 and 18:00. If you cannot be there at a certain hour, try to see if someone else can be at the delivery address to accept the parcel on your behalf.</p>

              <h3 className="font-normal mb-2">How will the packaging look like in case of a door delivery?</h3>
              <p className="mb-10">We ensure highest standards of packaging norms and deliver all our products in highly standardized Carton Boxes which will enable there are no damages while handling your items.</p>
            </div>

          </div>

        </div>
      </div>
      <Footer />
    </>
  )
}